export default __webpack_public_path__ + "static/media/Ун_1л.90abb646.jpg";